import { Base_Url } from "../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../ApiMethods/ApiMethod";

const Url = `${Base_Url}/DivisionalSubCategory`;

export const AddUpdateDivisionSubCategory = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/AddUpdateDivisionSubCategory`, requestJson
  );
  return res;
};

export const GetDivisionalSubCategoryModel = async (DSCKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetDivisionalSubCategoryModel?DSCKeyID=${DSCKeyID}`
  );
  return res;
};

export const GetDivisionSubCategoryList = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/GetDivisionSubCategoryList`, requestJson
  );
  return res;
};

export const UpdateSubDivisionalCategoryStatus = async (DSCKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/ChangeDivisionalSubCategoryStatus?DSCKeyID=${DSCKeyID}`
  );
  return res;
};


export const GetSubDivisionalCategoryLookupList = async (divisionalCategoryID) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetDivisionalSubCategoryLookupList?divisionalCategoryID=${divisionalCategoryID}`
  );
  return res;
};

export const GetSubDivisionalLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Url}/GetDivisionalSubCategoryLookupList?divisionalCategoryID`
  );
  return res;
};